﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconCalendarTime } from "@tabler/icons-react";
import { PersonalLicenciasDef } from "./PersonalLicenciasDef";

export const PersonalLicenciasIcon = IconCalendarTime;
export const PersonalLicenciasText = "* Aquí puede ver el historial de vacaciones, maternidad y otro tipo de licencias para esta persona";
export class PersonalLicencias extends Entity<PersonalLicenciasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalLicenciasDef(), parentKeys);
        super.Form = import('./PersonalLicenciasForm').then((module) => module.PersonalLicenciasForm);
        this.Title = "Licencias";
        this.Icon = PersonalLicenciasIcon;
        this.HelpText = PersonalLicenciasText;
    }
}